document.addEventListener('DOMContentLoaded', () => {
    const searchInput = document.getElementById('postal-code');
    const depotsList = document.querySelector('.product-depots__list');
    const modal = document.getElementById('depotSelectModal');

    // Éléments de la card-availabilities
    const stockStatus = document.getElementById('stockStatus');
    const stockDefault = document.getElementById('stockDefault');
    const selectedDepotName = document.getElementById('selectedDepotName');
    const changeDepotLink = document.getElementById('changeDepotLink');
    const selectDepotLink = document.getElementById('selectDepotLink');

    // Prix du produit
    const productPrice = document.getElementById('productPrice');

    // Filtrage par code postal
    if (searchInput && depotsList) {
        const depotCards = depotsList.querySelectorAll('.card-site');

        searchInput.addEventListener('input', () => {
            const searchValue = searchInput.value.trim();

            depotCards.forEach(card => {
                const postalCode = card.dataset.postalCode || '';

                if (searchValue === '' || postalCode.startsWith(searchValue)) {
                    card.style.display = '';
                } else {
                    card.style.display = 'none';
                }
            });
        });
    }

    // Modal du simulateur de tonnage
    const simulatorModal = document.getElementById('simulatorModal');

    // Sélection d'un dépôt
    if (depotsList) {
        depotsList.addEventListener('click', (e) => {
            const selectBtn = e.target.closest('.card-site__link');
            if (!selectBtn) return;


            const depotName = selectBtn.dataset.depotName;
            const depotPrice = selectBtn.dataset.depotPrice;
            const depotPriceRaw = parseFloat(selectBtn.dataset.depotPriceRaw) || 0;
            const depotTel       = (selectBtn.dataset.depotTelephone || '').replace(/\D/g, '');
            const depotTelFmt    = depotTel.match(/.{2}/g)?.join(' ') || '';
            const depotEmail     = selectBtn.dataset.depotEmail || '';

            if (selectedDepotName) {
                selectedDepotName.textContent = depotName;
            }

            if (productPrice) {
                productPrice.textContent = depotPrice + ' € HT';
            }

            // Mettre à jour le tarif dans le modal du calculateur de tonnage
            if (simulatorModal) {
                simulatorModal.dataset.minTarif = depotPriceRaw;

                // Émettre un événement pour notifier le changement de prix
                const event = new CustomEvent('depotPriceChanged', {
                    detail: { price: depotPriceRaw }
                });
                document.dispatchEvent(event);
            }

            // Mise à jour des contacts
            const telLink = document.querySelector('.simulator__contact-link[href^="tel"]');
            const mailLink = document.querySelector('.simulator__contact-link[href^="mailto"]');

            if (telLink && depotTel) {
                telLink.href        = 'tel:' + depotTel;
                telLink.textContent = depotTelFmt;
            }
            if (mailLink && depotEmail) {
                mailLink.href        = 'mailto:' + depotEmail;
                mailLink.textContent = depotEmail;
            }

            if (stockStatus) stockStatus.style.display = '';
            if (changeDepotLink) changeDepotLink.style.display = '';
            if (selectedDepotName) selectedDepotName.style.display = '';
            if (selectDepotLink) selectDepotLink.style.display = 'none';
            if (stockDefault) stockDefault.style.display = 'none';

            // Utiliser la fonction closeModal du sytème
            const closeDepotModal = window.modalCloseFunctions?.get('depotSelectModal');
            if (closeDepotModal) {
                closeDepotModal();
            }
        });
    }
});
